import { useState } from "react";
import AgentsAPI from "../../../api/AgentsAPI";

const useUpdateAgentProfile = () => {
	const [loading, setLoading] = useState(false);

	const updateAgentProfile = async (formData) => {
		setLoading(true);

		try {
			const result = await AgentsAPI.updateAgentProfile(formData);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to update agent profile:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		updateAgentProfile,
		loading,
	};
};

export default useUpdateAgentProfile;
